export default __webpack_public_path__ + "static/media/growthnote-bg-img3x.f5f86c19.png";